// Settings configured here will be merged into the final config object.

const mapWidth = 1000
const mapHeight = 630

export default {
  apiEndpoint: 'https://steuerbelastungskarte.firebaseio.com',
  mapHeight,
  mapWidth,
  screenUnit: mapWidth / (window.innerWidth - 26)
}
